import { useCallback, useEffect, useState, createRef } from 'react';
import * as anchor from '@project-serum/anchor';
import styled from 'styled-components';
import { Container, Snackbar } from '@mui/material';
import Paper from '@mui/material/Paper';
import Alert from '@mui/lab/Alert';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
//import * as dotenv from 'dotenv';
//import { AiFillDollarCircle } from "react-icons/ai";
//dotenv.config()
import { Commitment, Connection, PublicKey, Transaction } from '@solana/web3.js';
import { useAnchorWallet, useWallet } from '@solana/wallet-adapter-react';
import { WalletDialogButton } from '@solana/wallet-adapter-material-ui';
import {
  awaitTransactionSignatureConfirmation,
  CANDY_MACHINE_PROGRAM,
  CandyMachineAccount,
  createAccountsForMint,
  getCandyMachineState,
  getCollectionPDA,
  mintOneToken,
  SetupState
} from './candy-machine';
//import {getServerApiUrl} from './utils/server-db';
import { AlertState, formatNumber, getAtaForMint, toDate } from './utils';
import { MintCountdown } from './MintCountdown';
import { MintButton } from './MintButton';
import { GatewayProvider } from '@civic/solana-gateway-react';
import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
import { SolanaMobileWalletAdapterWalletName } from '@solana-mobile/wallet-adapter-mobile';
import { SiDiscord, /*SiTwitter,*/ SiBrave } from 'react-icons/si';
import { MdEmail } from 'react-icons/md';
import { RiTwitterXFill } from 'react-icons/ri';
//import { FaConnectdevelop, FaChartPie } from 'react-icons/fa';
import { FaChrome, FaFirefox } from 'react-icons/fa';
import { IconContext } from 'react-icons';
import CrossMint from './components/Payment/CrossMint';
import { BrowserView, MobileView /*isBrowser, isMobile, isIE, CustomView*/ } from 'react-device-detect';
//import axios from 'axios';

import {
  /*WalletMultiButton,*/
  WalletDisconnectButton
} from '@solana/wallet-adapter-react-ui';
//solana wallet provider and css styles
require('@solana/wallet-adapter-react-ui/styles.css');
import Spline from '@splinetool/react-spline';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/solid';
import PhoneWarnModal from './components/Modal/PhoneWarnModal';
//import { NullLiteral } from 'typescript';

const ConnectButton = styled(WalletDialogButton)`
  width: 100%;
  height: 60px;
  margin-top: 10px;
  margin-bottom: 5px;
  background: linear-gradient(180deg, #604ae5 0%, #813eee 100%);
  color: white;
  font-size: 12px;
  font-weight: bold;
  font-family: 'Press Start 2P';
  @media (max-width: 648px) {
    font-size: 12px;
  },
  @media (max-width: 468px) {
    font-size: 9px;
  },
`;

const ActionButton = styled.button`
  border-radius: 5px;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.65rem;
  padding-bottom: 0.65rem;
  background: linear-gradient(180deg, #604ae5 0%, #813eee 100%);
  color: white;
  font-size: 10px;
  font-weight: 600;
  cursor: pointer;
  text-transform: uppercase;
  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
`;
const OptionsButton = styled.button`
  border-radius: 5px;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  background: linear-gradient(180deg, #604ae5 0%, #813eee 100%);
  color: white;
  font-size: 11px;
  font-weight: bold;
  cursor: pointer;
  text-transform: uppercase;
  font-family: 'Press Start 2P';
`;
//Spline container
const SplineWrapper = styled.div`
  height: 100vh;
  width: 100%;
  font-family: 'Spline Sans', sans-serif;
  font-size: 15px;
  color: white;
  position: relative;
  .spline {
    height: 100%;
    position: absolute;
    margin: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    @media (max-width: 500px) {
      display: none;
    },
  }
`;
function handleEmailTo() {
  //e.preventDefault();
  const length = 6;
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let code = '';
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    code += characters.charAt(randomIndex);
  }
  const email = 'support@metatedstudio.com';
  const subject = `Ticket #${code} - Support raised!`;
  const body = `DISCLAIMER: This email is intended solely for the recipient(s) identified above and may contain confidential and privileged information. If you didn't intend to initiate this email, delete this email or any drafts saved from your system or email provider. Any unauthorized use or disclosure of this email is strictly prohibited. Please write your email below and don't forget to add you signature at the end so we know who this email is from.`;
  const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  //const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}
  //alertMessage('Email provider opened', 'success');
  console.log('Opening email provider....');
  window.location.href = mailtoLink;
}
const MintContainer = styled.div``; // add your owns styles here
//Security measure to validate external site urls
function valURL(url: string): boolean {
  const parsed = new URL(url);
  return ['https:', 'http:'].includes(parsed.protocol);
}
const SocialMediaLinks = [
  {
    name: 'Mail',
    icon: <MdEmail />,
    href: `#`,
    onclick: handleEmailTo,
    disabled: true
  },
  {
    name: 'Discord',
    icon: <SiDiscord />,
    href: `https://discord.gg/N5wB8JTBBS`,
    target: '_blank',
    disabled: true,
    rel: 'noopener noreferrer'
  },
  {
    name: 'Twitter',
    icon: <RiTwitterXFill />,
    disabled: false,
    target: '_blank',
    rel: 'noopener noreferrer',
    href: 'https://twitter.com/metateds'
  }
];
const BrowserLinks = [
  {
    name: 'Chrome',
    icon: <FaChrome />
  },
  {
    name: 'Brave',
    icon: <SiBrave />
  },
  {
    name: 'Firefox',
    icon: <FaFirefox />
  }
];
export interface HomeProps {
  candyMachineId?: anchor.web3.PublicKey;
  connection: anchor.web3.Connection;
  txTimeout: number;
  rpcHost: string;
  network: WalletAdapterNetwork;
  error?: string;
  env?: string;
}
const Home = (props: HomeProps) => {
  //footer states
  const [socialMediaLinks] = useState(SocialMediaLinks);
  const [browserLinks] = useState(BrowserLinks);
  //states
  const [isUserMinting, setIsUserMinting] = useState(false);
  const [candyMachine, setCandyMachine] = useState<CandyMachineAccount>();
  const [alertState, setAlertState] = useState<AlertState>({
    open: false,
    message: '',
    severity: undefined
  });
  const [isActive, setIsActive] = useState<boolean>(false);
  const [endDate, setEndDate] = useState<Date>();
  const [itemsRemaining, setItemsRemaining] = useState<number>();
  const [isWhitelistUser, setIsWhitelistUser] = useState(false);
  const [isPresale, setIsPresale] = useState(false);
  const [isValidBalance, setIsValidBalance] = useState(false);
  const [discountPrice, setDiscountPrice] = useState<anchor.BN>();
  const [needTxnSplit, setNeedTxnSplit] = useState(true);
  const [setupTxn, setSetupTxn] = useState<SetupState>();
  const [isLoadingSpline, setIsSplineLoading] = useState<boolean>(true);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  //const [activate, setIsActivate] = useState<boolean>(false);
  const ref = createRef<HTMLDivElement>();
  const rpcUrl = props.rpcHost;
  const anchorWallet = useAnchorWallet();
  const { connect, connected, publicKey, wallet } = useWallet();
  const cluster = props.network;
  //const [userExists, setUserExists] = useState(false);
  //const [previousWalletAddress, setPreviousWalletAddress] = useState<string>('');
  //const [mintStatus, setMintStatus] = useState<any>('');

  /***Mongodb Util - WIP*/
  /*props.env === 'development' ? (axios.defaults.baseURL = process.env.REACT_APP_BASE_URL) : null;
  useEffect(() => {
    if (!wallet) {
      return;
    } else {
      // Fetch users only if the Solana wallet address changes
      if (publicKey?.toString() !== previousWalletAddress) {
      // Check if the user exists in MongoDB when the component mounts
      checkWalletExists()
        .then(() => {
          if (userExists) {
            storeWalletAddress();
            //setPreviousWalletAddress(walletAddress);
          }
        })
        .catch((error) => {
          console.log(`Error checking for existing user: ${error}`);
        });
      }
    }
  }, [wallet, publicKey, userExists]);
  useEffect(() => {
    if (!connected){
      handleDisconnect();
    }
    // Listen for wallet disconnect event
    //window.addEventListener(connected, handleDisconnect);
    //return () => {
      // Cleanup: remove the listener when the component unmounts
      //window.removeEventListener(connected, handleDisconnect);
    //};
  }, [connected]);
  const handleDisconnect = async () => {
    // Send an error notification to the server
    try {
      const response = await axios.post('/api/v1/user/disconnect', {
        message: 'Solana wallet disconnected!'
      });
      console.log(response.data.msg);
    } catch(error) {
      console.error('Error sending wallet disconnect notification to server:', error);
    }
    
  };
  const checkWalletExists = async () => {
    try {
      const walletAddress = publicKey?.toString();
      const response = await axios.get(`/api/v1/user/info`, {
        params: { walletAddress }
      });
      //const response = await axios.get(`${server_url}/api/v1/user/info?id=${walletAddress}`);
      if (response.data.exists === true) {
        console.log('Status checked: ', response.data);
        setUserExists(true); //response.data.exists or response.data.success
      }
      setUserExists(false);
    } catch (error) {
      console.error('Error checking user existence:', error);
    }
  };
  const storeWalletAddress = async () => {
    try {
      // Send a request to store the Solana wallet address in MongoDB if the user doesn't exist
      if (!userExists) {
        const response = await axios.post(`/api/v1/user/create`, {
          solanaWalletAddress: publicKey?.toString(),
          mint: false
        });
        console.log('User wallet stored successfully:', response.data);
        // Update user existence status
        setUserExists(true);
      }
    } catch (error) {
      console.error('Error storing user address:', error);
    }
  };*/
  /*const storeMintStatus = async () => {
    try {
      // Send the wallet address, mintStatus to the backend
      // Send a request to store the Solana wallet address in MongoDB
      if (!mintStatus) {
        const response = await axios.post('/', { 
          walletAddress, //solanaWalletAddress: publicKey,
          minted: true,  
        });
        if (response.data) {
          console.log('Successfully stored wallet address and mint session', response.data);
        }
      }
    } catch (error) {
      console.error('Error storing wallet address and mint session:', error);
      //setStatus('An error occurred. Please try again.');
    }
  }*/

  //declare types
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
    console.log(isOpen);
  };
  /*
  //detect mobile device type
  const isMobileCheck = () => {
    let check = false;
    (function(a){
      if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) 
        check = true;
    })(navigator.userAgent||navigator.vendor||window.opera);
    //return check;
    setIsMobile(check)
  };
  //detect touch enabled devices
  const isMobileTabletCheck = () => {
    let check = false;
    (function(a){
        if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) 
            check = true;
    })(navigator.userAgent||navigator.vendor||window.opera);
    //return check;
    setIsMobileTablet(check)
  }*/
  const refreshCandyMachineState = useCallback(
    async (commitment: Commitment = 'confirmed') => {
      if (!publicKey) {
        return;
      }
      if (props.error !== undefined) {
        setAlertState({
          open: true,
          message: props.error,
          severity: 'error',
          hideDuration: null
        });
        return;
      }
      const connection = new Connection(props.rpcHost, commitment);
      if (props.candyMachineId) {
        try {
          const cndy = await getCandyMachineState(anchorWallet as anchor.Wallet, props.candyMachineId, connection);
          console.log('Candy machine state: ', cndy);
          let active = cndy?.state.goLiveDate ? cndy?.state.goLiveDate.toNumber() < new Date().getTime() / 1000 : false;
          let presale = false;
          // duplication of state to make sure we have the right values!
          let isWLUser = false;
          let userPrice = cndy.state.price;
          // whitelist mint?
          if (cndy?.state.whitelistMintSettings) {
            // is it a presale mint?
            if (cndy.state.whitelistMintSettings.presale && (!cndy.state.goLiveDate || cndy.state.goLiveDate.toNumber() > new Date().getTime() / 1000)) {
              presale = true;
            }
            // is there a discount?
            if (cndy.state.whitelistMintSettings.discountPrice) {
              setDiscountPrice(cndy.state.whitelistMintSettings.discountPrice);
              userPrice = cndy.state.whitelistMintSettings.discountPrice;
            } else {
              setDiscountPrice(undefined);
              // when presale=false and discountPrice=null, mint is restricted
              // to whitelist users only
              if (!cndy.state.whitelistMintSettings.presale) {
                cndy.state.isWhitelistOnly = true;
              }
            }
            // retrieves the whitelist token
            const mint = new anchor.web3.PublicKey(cndy.state.whitelistMintSettings.mint);
            const token = (await getAtaForMint(mint, publicKey))[0];

            try {
              const balance = await connection.getTokenAccountBalance(token);
              isWLUser = parseInt(balance.value.amount) > 0;
              // only whitelist the user if the balance > 0
              setIsWhitelistUser(isWLUser);

              if (cndy.state.isWhitelistOnly) {
                active = isWLUser && (presale || active);
              }
            } catch (e) {
              setIsWhitelistUser(false);
              // no whitelist user, no mint
              if (cndy.state.isWhitelistOnly) {
                active = false;
              }
              console.log('There was a problem fetching whitelist token balance');
              console.log(e);
            }
          }
          userPrice = isWLUser ? userPrice : cndy.state.price;

          if (cndy?.state.tokenMint) {
            // retrieves the SPL token
            const mint = new anchor.web3.PublicKey(cndy.state.tokenMint);
            const token = (await getAtaForMint(mint, publicKey))[0];
            try {
              const balance = await connection.getTokenAccountBalance(token);

              const valid = new anchor.BN(balance.value.amount).gte(userPrice);

              // only allow user to mint if token balance >  the user if the balance > 0
              setIsValidBalance(valid);
              active = active && valid;
            } catch (e) {
              setIsValidBalance(false);
              active = false;
              // no whitelist user, no mint
              console.log('There was a problem fetching SPL token balance');
              console.log(e);
            }
          } else {
            const balance = new anchor.BN(await connection.getBalance(publicKey));
            const valid = balance.gte(userPrice);
            setIsValidBalance(valid);
            active = active && valid;
          }

          // datetime to stop the mint?
          if (cndy?.state.endSettings?.endSettingType.date) {
            setEndDate(toDate(cndy.state.endSettings.number));
            if (cndy.state.endSettings.number.toNumber() < new Date().getTime() / 1000) {
              active = false;
            }
          }
          // amount to stop the mint?
          if (cndy?.state.endSettings?.endSettingType.amount) {
            const limit = Math.min(cndy.state.endSettings.number.toNumber(), cndy.state.itemsAvailable);
            if (cndy.state.itemsRedeemed < limit) {
              setItemsRemaining(limit - cndy.state.itemsRedeemed);
            } else {
              setItemsRemaining(0);
              cndy.state.isSoldOut = true;
            }
          } else {
            setItemsRemaining(cndy.state.itemsRemaining);
          }

          if (cndy.state.isSoldOut) {
            active = false;
          }

          const [collectionPDA] = await getCollectionPDA(props.candyMachineId);
          const collectionPDAAccount = await connection.getAccountInfo(collectionPDA);

          setIsActive((cndy.state.isActive = active));
          setIsPresale((cndy.state.isPresale = presale));
          setCandyMachine(cndy);

          const txnEstimate =
            892 +
            (!!collectionPDAAccount && cndy.state.retainAuthority ? 182 : 0) +
            (cndy.state.tokenMint ? 66 : 0) +
            (cndy.state.whitelistMintSettings ? 34 : 0) +
            (cndy.state.whitelistMintSettings?.mode?.burnEveryTime ? 34 : 0) +
            (cndy.state.gatekeeper ? 33 : 0) +
            (cndy.state.gatekeeper?.expireOnUse ? 66 : 0);

          setNeedTxnSplit(txnEstimate > 1230);
        } catch (e) {
          if (e instanceof Error) {
            if (e.message === `Account does not exist ${props.candyMachineId}`) {
              setAlertState({
                open: true,
                message: `Couldn't fetch candy machine state from candy machine with address: ${props.candyMachineId}, using rpc: ${props.rpcHost}! You probably typed the REACT_APP_CANDY_MACHINE_ID value wrong in your .env file, or you are using the wrong RPC!`,
                severity: 'error',
                hideDuration: null
              });
            } else if (e.message.startsWith('failed to get info about account')) {
              setAlertState({
                open: true,
                message: `Couldn't fetch candy machine state with rpc: ${props.rpcHost}! This probably means you have an issue with the REACT_APP_SOLANA_RPC_HOST value in your .env file, or you are not using a custom RPC!`,
                severity: 'error',
                hideDuration: null
              });
            }
          } else {
            setAlertState({
              open: true,
              message: `${e}`,
              severity: 'error',
              hideDuration: null
            });
          }
          console.log(e);
        }
      } else {
        setAlertState({
          open: true,
          message: `Your REACT_APP_CANDY_MACHINE_ID value in the .env file doesn't look right! Make sure you enter it in as plain base-58 address!`,
          severity: 'error',
          hideDuration: null
        });
      }
    },
    [anchorWallet, props.candyMachineId, props.error, props.rpcHost]
  );
  const onMint = async (beforeTransactions: Transaction[] = [], afterTransactions: Transaction[] = []) => {
    try {
      setIsUserMinting(true);
      if (connected && candyMachine?.program && publicKey) {
        let setupMint: SetupState | undefined;
        if (needTxnSplit && setupTxn === undefined) {
          setAlertState({
            open: true,
            message: 'Please sign account setup transaction',
            severity: 'info'
          });
          setupMint = await createAccountsForMint(candyMachine, publicKey);
          let status: any = { err: true };
          if (setupMint.transaction) {
            status = await awaitTransactionSignatureConfirmation(setupMint.transaction, props.txTimeout, props.connection, true);
          }
          if (status && !status.err) {
            setSetupTxn(setupMint);
            setAlertState({
              open: true,
              message: 'Setup transaction succeeded! Please sign minting transaction',
              severity: 'info'
            });
          } else {
            setAlertState({
              open: true,
              message: 'Mint failed! Please try again!',
              severity: 'error'
            });
            setIsUserMinting(false);
            return;
          }
        } else {
          setAlertState({
            open: true,
            message: 'Please sign minting transaction',
            severity: 'info'
          });
        }

        const mintResult = await mintOneToken(candyMachine, publicKey, beforeTransactions, afterTransactions, setupMint ?? setupTxn);

        let status: any = { err: true };
        let metadataStatus = null;
        if (mintResult) {
          status = await awaitTransactionSignatureConfirmation(mintResult.mintTxId, props.txTimeout, props.connection, true);

          metadataStatus = await candyMachine.program.provider.connection.getAccountInfo(mintResult.metadataKey, 'processed');
          console.log('Metadata status: ', !!metadataStatus);
        }

        if (status && !status.err && metadataStatus) {
          // manual update since the refresh might not detect
          // the change immediately
          const remaining = itemsRemaining! - 1;
          setItemsRemaining(remaining);
          setIsActive((candyMachine.state.isActive = remaining > 0));
          candyMachine.state.isSoldOut = remaining === 0;
          setSetupTxn(undefined);
          setAlertState({
            open: true,
            message: 'Congratulations! Mint succeeded!',
            severity: 'success',
            hideDuration: 7000
          });
          refreshCandyMachineState('processed');
        } else if (status && !status.err) {
          setAlertState({
            open: true,
            message: 'Mint likely failed! Anti-bot SOL 0.01 fee potentially charged! Check the explorer to confirm the mint failed and if so, make sure you are eligible to mint before trying again.',
            severity: 'error',
            hideDuration: 8000
          });
          refreshCandyMachineState();
        } else {
          setAlertState({
            open: true,
            message: 'Mint failed! Please try again!',
            severity: 'error'
          });
          refreshCandyMachineState();
        }
      }
    } catch (error: any) {
      let message = error.msg || 'Minting failed! Please try again!';
      if (!error.msg) {
        if (!error.message) {
          message = 'Transaction timeout! Please try again.';
        } else if (error.message.indexOf('0x137')) {
          console.log(error);
          message = `SOLD OUT!`;
        } else if (error.message.indexOf('0x135')) {
          message = `Insufficient funds to mint. Please fund your wallet.`;
        }
      } else {
        if (error.code === 311) {
          console.log(error);
          message = `SOLD OUT!`;
          window.location.reload();
        } else if (error.code === 312) {
          message = `Minting period hasn't started yet.`;
        }
      }

      setAlertState({
        open: true,
        message,
        severity: 'error'
      });
      // updates the candy machine state to reflect the latest
      // information on chain
      refreshCandyMachineState();
    } finally {
      setIsUserMinting(false);
    }
  };
  const toggleMintButton = () => {
    let active = !isActive || isPresale;

    if (active) {
      if (candyMachine!.state.isWhitelistOnly && !isWhitelistUser) {
        active = false;
      }
      if (endDate && Date.now() >= endDate.getTime()) {
        active = false;
      }
    }

    if (isPresale && candyMachine!.state.goLiveDate && candyMachine!.state.goLiveDate.toNumber() <= new Date().getTime() / 1000) {
      setIsPresale((candyMachine!.state.isPresale = false));
    }

    setIsActive((candyMachine!.state.isActive = active));
  };

  /*
    const menuListContainer = {
      marginTop: '0.25rem',
      flexDirection: 'column',
      position: 'relative',
      textAlign: 'center',
      alignItems: 'center',
    }
    const menuListBtn = {
      margin: '0.25rem auto 0',
      height: 'full',
      display: 'flex',
      textAlign: 'center',
      alignItems: 'center',
    }
  */
  /*
    const menuDropDown = {
      top: '100%',
      left: '-50%',
      right: '-50%',
      width: '12rem',
      margin: '0.75rem auto',
      position: 'absolute',
      zIndex: 99,
      display: 'grid',
      borderRadius: '0.5rem',
      padding: '0.75rem',
      alignItems: 'center',
      gap: '0.5rem',
      cursor: 'pointer',
      opacity: 100,
      backgroundColor: 'rgb(30 41 59,1)',
      gridTemplateRows: 'repeat(1, minmax(0, 1fr))',
    }
  */
  /*const menuList = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '0.75rem 0'
  }*/
  const menuListPlatform = {
    width: '100%',
    alignItems: 'center'
  };
  const splineStyles = {
    height: '100vh',
    width: '100%',
    top: 0,
    left: 0
  };
  /*const menuListGallery = {
    width: '100%',
    alignItems: 'center'
  }*/
  const containerStyles = {
    height: '100vh',
    width: '100%',
    backgroundImage: 'url("/loading_backdrop.gif")',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'fixed',
    backgroundPosition: 'center bottom',
    backgroundSize: '95%',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    '@media (maxWidth: 500px)': {
      display: 'none'
    },
    '@media (minWidth: 640px)': {
      backgroundPosition: 'top',
      backgroundSize: 'cover'
    },
    '@media (minWidth: 1024px)': {
      backgroundSize: 'cover',
      backgroundPosition: 'top left' // Styles for screens wider than 1024px
    },
    '@media (maxWidth: 468px)': {
      backgroundSize: '75%', // Styles for screens up to 468px wide
      backgroundPosition: 'center top'
    }
  };
  /*useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor
    // Regular expression to check if the userAgent indicates a mobile device
    const mobileDeviceRegex = /android|iphone|ipod|ipad|iemobile|opera mini/i;
    const IsMobile = mobileDeviceRegex.test(userAgent);
    if (IsMobile) {
      setIsMobile(true);
    }
  }, []);*/
  useEffect(() => {
    const HandleClickOutside = (e: MouseEvent | KeyboardEvent) => {
      // check if element that was clicked is inside of ref'd component
      // if so no action is required from this event listener so exit
      if (ref.current && ref.current.contains(e.target as Node)) {
        return;
      }
      // else close the dropdown
      setIsOpen(false);
    };
    document.body.addEventListener('click', HandleClickOutside);
    // CLEANUP
    // remove event listener
    return () => {
      document.body.removeEventListener('click', HandleClickOutside);
    };
  }, []);
  useEffect(() => {
    // Set a timeout to delay the appearance of the modal (e.g., 2000 milliseconds = 2 seconds)
    const delayTimeout = setTimeout(() => {
      setShowModal(true);
    }, 1000);
    // Clear the timeout if the component is unmounted before the delay completes
    return () => clearTimeout(delayTimeout);
  }, []); // Run this effect only once when the component mounts
  useEffect(() => {
    const simulateLoadingState = () => {
      setTimeout(() => {
        setIsSplineLoading(false);
      }, 3000); //simulating 5 second load time
    };
    simulateLoadingState();
  }, []);
  useEffect(() => {
    refreshCandyMachineState();
  }, [anchorWallet, props.candyMachineId, props.connection, refreshCandyMachineState]);
  /*useEffect(() => {
    storeWalletAddress();
  }, []);*/
  useEffect(() => {
    (function loop() {
      setTimeout(() => {
        refreshCandyMachineState();
        loop();
      }, 20000);
    })();
  }, [refreshCandyMachineState]);

  /*function onLoad(spline) {
    const obj = spline.findObjectByName('Cube');
    // or
    // const obj = spline.findObjectById('8E8C2DDD-18B6-4C54-861D-7ED2519DE20E');

    // save it in a ref for later use
    cube.current = obj;
  }
  function moveObj() {
    console.log(cube.current); // Spline Object => { name: 'Cube', id: '8E8C2DDD-18B6-4C54-861D-7ED2519DE20E', position: {}, ... }

    // move the object in 3D space
    cube.current.position.x += 10;
  }*/
  //for mobile view
  /*const isMobileView = () => {
    if (isMobile) {
      return (
        <>
        {showModal && <PhoneWarnModal />}
        </>
      )
    }
    return(
      <>
      {isLoadingSpline ?  (
        <div className={`absolute loading-display`} style={containerStyles}></div>
      ):(
        <div className="absolute" style={splineStyles}>
          {<SplineWrapper>
            <Spline className='spline' 
              scene="https://prod.spline.design/TdH3gThWW9N6BOa0/scene.splinecode"
            />
          </SplineWrapper>}
        </div>
      )}
      </>
    )
  }*/
  return (
    <>
      <MobileView>{showModal && <PhoneWarnModal />}</MobileView>
      <BrowserView>
        {isLoadingSpline ? (
          <div className={`absolute loading-display`} style={containerStyles}></div>
        ) : (
          <div className="absolute" style={splineStyles}>
            {
              <SplineWrapper>
                <Spline className="spline" scene="https://prod.spline.design/TdH3gThWW9N6BOa0/scene.splinecode" />
              </SplineWrapper>
            }
          </div>
        )}
      </BrowserView>
      <div style={{ display: 'block' }}>
        <Container style={{ marginTop: 100 }}>
          <Container maxWidth="xs" style={{ position: 'relative' }}>
            <Paper
              style={{
                padding: 24,
                paddingBottom: 10,
                backgroundColor: '#151A1F',
                borderRadius: 6
              }}
            >
              <Typography variant="caption" align="center" display="block" style={{ marginBottom: 7, color: 'grey', fontWeight: 800, fontSize: '15px' }}>
                Get Your Ticket to AER30
              </Typography>
              {!connected ? (
                <>
                  <ConnectButton
                    onClick={(e) => {
                      if (wallet?.adapter.name === SolanaMobileWalletAdapterWalletName) {
                        connect();
                        e.preventDefault();
                      }
                    }}
                  >
                    Connect Wallet
                  </ConnectButton>
                  <CrossMint mode={'single'} wallet={''} connection={false} />
                </>
              ) : (
                <>
                  <div
                    id="menu-container"
                    style={{
                      margin: '0.4rem auto',
                      pointerEvents: 'auto',
                      position: 'relative',
                      textAlign: 'center',
                      alignItems: 'center',
                      height: '100%'
                    }}
                  >
                    <ul
                      id="ExploreMintDropdown"
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        borderRadius: '0.5rem',
                        padding: '0.75rem',
                        alignItems: 'center',
                        cursor: 'pointer',
                        opacity: 100,
                        backgroundColor: '#151A1F',
                        gridTemplateRows: 'repeat(1, minmax(0, 1fr))',
                        listStyleType: 'none'
                      }}
                      aria-label="dropdown-list"
                      role="menu"
                    >
                      <li
                        id="option-wallet"
                        style={{
                          width: '100%',
                          alignItems: 'center',
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'center',
                          gap: '0.75rem'
                        }}
                      >
                        <WalletDisconnectButton
                          style={{
                            background: 'linear-gradient(180deg, #604ae5 0%, #813eee 100%)',
                            maxWidth: '128px',
                            maxHeight: '38px',
                            height: '100%',
                            width: '100%',
                            paddingLeft: '1rem',
                            paddingRight: '1rem',
                            paddingTop: '.55rem',
                            paddingBottom: '.55rem',
                            lineHeight: '1.25rem',
                            fontSize: '10px',
                            textAlign: 'center',
                            display: 'inline-flex',
                            justifyContent: 'center',
                            borderRadius: '5px',
                            textTransform: 'uppercase',
                            fontWeight: 'bold',
                            fontFamily: 'Press Start 2P'
                          }}
                        />
                        <a href={valURL('https://metateds.com') ? 'https://metateds.com' : ''} target="_blank" rel="noopener noreferrer">
                          <ActionButton>Sign Into Platform</ActionButton>
                        </a>
                        {/*<div id="option-platform" style={menuListPlatform}>
                          <div style={{ marginBottom: '', marginTop: '1rem' }}>
                            <a href={valURL('https://metateds.com') ? 'https://metateds.com' : ''} target="_blank" rel="noopener noreferrer">
                              <ActionButton>Sign Into Platform</ActionButton>
                            </a>
                          </div>
                        </div>*/}
                      </li>
                    </ul>
                  </div>
                  {candyMachine && (
                    <Grid container direction="row" justifyContent="center" wrap="nowrap">
                      <Grid item xs={3}>
                        <Typography variant="body2" color="textSecondary">
                          Remaining
                        </Typography>
                        <Typography
                          variant="h6"
                          color="textPrimary"
                          style={{
                            fontWeight: 'bold'
                          }}
                        >
                          {`${itemsRemaining}`}
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Typography variant="body2" color="textSecondary">
                          {isWhitelistUser && discountPrice ? 'Discount Price' : 'Price'}
                        </Typography>
                        <Typography variant="h6" color="textPrimary" style={{ fontWeight: 'bold' }}>
                          {isWhitelistUser && discountPrice ? `◎ ${formatNumber.asNumber(discountPrice)}` : `◎ ${formatNumber.asNumber(candyMachine.state.price)}`}
                        </Typography>
                      </Grid>
                      <Grid item xs={5}>
                        {isActive && endDate && Date.now() < endDate.getTime() ? (
                          <>
                            <MintCountdown key="endSettings" date={getCountdownDate(candyMachine)} style={{ justifyContent: 'flex-end' }} status="COMPLETED" onComplete={toggleMintButton} />
                            <Typography variant="caption" align="center" display="block" style={{ fontWeight: 'bold' }}>
                              TO END OF MINT
                            </Typography>
                          </>
                        ) : (
                          <>
                            <MintCountdown
                              key="goLive"
                              date={getCountdownDate(candyMachine)}
                              style={{ justifyContent: 'flex-end' }}
                              status={candyMachine?.state?.isSoldOut || (endDate && Date.now() > endDate.getTime()) ? 'COMPLETED' : isPresale ? 'PRESALE' : 'LIVE'}
                              onComplete={toggleMintButton}
                            />
                            {isPresale && candyMachine.state.goLiveDate && candyMachine.state.goLiveDate.toNumber() > new Date().getTime() / 1000 && (
                              <Typography variant="caption" align="center" display="block" style={{ fontWeight: 'bold' }}>
                                UNTIL PUBLIC MINT
                              </Typography>
                            )}
                          </>
                        )}
                      </Grid>
                    </Grid>
                  )}
                  <MintContainer>
                    {candyMachine?.state.isActive && candyMachine?.state.gatekeeper && publicKey && anchorWallet?.signTransaction ? (
                      <GatewayProvider
                        wallet={{
                          publicKey: publicKey || new PublicKey(CANDY_MACHINE_PROGRAM),
                          signTransaction: anchorWallet.signTransaction
                        }}
                        gatekeeperNetwork={candyMachine?.state?.gatekeeper?.gatekeeperNetwork}
                        clusterUrl={rpcUrl}
                        cluster={cluster}
                        options={{ autoShowModal: false }}
                      >
                        <MintButton
                          candyMachine={candyMachine}
                          isMinting={isUserMinting}
                          setIsMinting={(val) => setIsUserMinting(val)}
                          onMint={onMint}
                          isActive={isActive || (isPresale && isWhitelistUser && isValidBalance)}
                        />
                      </GatewayProvider>
                    ) : (
                      <MintButton
                        candyMachine={candyMachine}
                        isMinting={isUserMinting}
                        setIsMinting={(val) => setIsUserMinting(val)}
                        onMint={onMint}
                        isActive={isActive || (isPresale && isWhitelistUser && isValidBalance)}
                      />
                    )}
                  </MintContainer>
                  <CrossMint mode={'single'} connection={true} wallet={`${publicKey ? publicKey?.toString() : ''}`} />
                  {/*<p>{`${publicKey?.toString()}`}</p>*/}
                </>
              )}
              <Typography variant="caption" align="center" display="block" style={{ marginTop: 7, color: 'grey' }}>
                Powered by METAPLEX
              </Typography>
            </Paper>
          </Container>
          <Snackbar open={alertState.open} autoHideDuration={alertState.hideDuration === undefined ? 6000 : alertState.hideDuration} onClose={() => setAlertState({ ...alertState, open: false })}>
            <Alert onClose={() => setAlertState({ ...alertState, open: false })} severity={alertState.severity}>
              {alertState.message}
            </Alert>
          </Snackbar>
        </Container>
        {!connected && (
          <div
            style={{
              marginTop: '1rem',
              marginLeft: 'auto',
              marginRight: 'auto',
              marginBottom: '1.5rem',
              display: 'flex',
              justifyContent: 'center',
              pointerEvents: 'auto',
              position: 'relative'
            }}
          >
            <div
              id="menu-container"
              style={{
                margin: '0.25rem auto 1rem',
                flexDirection: 'column',
                position: 'relative',
                textAlign: 'center',
                alignItems: 'center',
                height: '100%'
              }}
            >
              {isOpen && (
                <div
                  id="menu-btn-container"
                  style={{
                    margin: '0.2rem auto 0',
                    height: 'full',
                    display: 'flex',
                    textAlign: 'center',
                    alignItems: 'center'
                  }}
                  ref={ref}
                >
                  <OptionsButton id="ExploreMint" type="button" onClick={() => toggleDropdown}>
                    <span style={{ display: 'inline-flex', alignItems: 'baseline' }}>
                      <span>Explore</span>
                      <span>
                        {!isOpen ? (
                          <ChevronDownIcon style={{ height: '0.75rem', width: '1.1rem', marginLeft: '3px' }} />
                        ) : (
                          <ChevronUpIcon style={{ height: '0.75rem', width: '1.1rem', marginLeft: '3px' }} />
                        )}
                      </span>
                      <span>{isOpen.toString()}</span>
                    </span>
                  </OptionsButton>
                </div>
              )}
              {!isOpen && (
                <ul
                  id="ExploreMintDropdown"
                  style={{
                    width: '12rem',
                    margin: '0.75rem auto 7rem',
                    position: 'relative',
                    justifyContent: 'center',
                    zIndex: 99,
                    display: 'flex',
                    borderRadius: '0.5rem',
                    padding: '0.75rem',
                    alignItems: 'center',
                    gap: '0.5rem',
                    cursor: 'pointer',
                    opacity: 100,
                    backgroundColor: '#151A1F',
                    gridTemplateRows: 'repeat(1, minmax(0, 1fr))',
                    listStyleType: 'none'
                  }}
                  aria-label="dropdown-list"
                  role="menu"
                >
                  <div
                    id="options-flex"
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      margin: '0.5rem 0'
                    }}
                  >
                    <li id="option-wallet" style={{ width: '100%', alignItems: 'center' }}>
                      <div id="option-platform" style={menuListPlatform}>
                        <a href={valURL('https://metateds.com') ? 'https://metateds.com' : ''} target="_blank" rel="noopener noreferrer">
                          <ActionButton>Sign Into Platform</ActionButton>
                        </a>
                      </div>
                    </li>
                  </div>
                </ul>
              )}
            </div>
          </div>
        )}
        {connected && (
          <div
            style={{
              marginTop: '1rem',
              marginLeft: 'auto',
              marginRight: 'auto',
              marginBottom: '1.5rem',
              display: 'flex',
              justifyContent: 'center',
              pointerEvents: 'auto',
              position: 'relative'
            }}
          >
            <div
              id="menu-container"
              style={{
                margin: '0.75rem auto 7rem',
                flexDirection: 'column',
                position: 'relative',
                textAlign: 'center',
                alignItems: 'center',
                height: '100%'
              }}
            >
              {/*isOpen && (
                <div
                  id="menu-btn-container"
                  style={{
                    margin: '0.2rem auto 0',
                    height: 'full',
                    display: 'flex',
                    textAlign: 'center',
                    alignItems: 'center'
                  }}
                  ref={ref}
                >
                  <OptionsButton id="ExploreMint" type="button" onClick={() => toggleDropdown}>
                    <span style={{ display: 'inline-flex', alignItems: 'baseline' }}>
                      <span>Explore</span>
                      <span>
                        {!isOpen ? (
                          <ChevronDownIcon style={{ height: '0.75rem', width: '1.1rem', marginLeft: '3px' }} />
                        ) : (
                          <ChevronUpIcon style={{ height: '0.75rem', width: '1.1rem', marginLeft: '3px' }} />
                        )}
                      </span>
                      <span>{isOpen.toString()}</span>
                    </span>
                  </OptionsButton>
                </div>
                        )*/}
              {/*!isOpen && (
                <ul
                  id="ExploreMintDropdown"
                  style={{
                    width: '12rem',
                    margin: '0.75rem auto 7rem',
                    position: 'relative',
                    justifyContent: 'center',
                    zIndex: 99,
                    display: 'flex',
                    borderRadius: '0.5rem',
                    padding: '0.75rem',
                    alignItems: 'center',
                    gap: '0.5rem',
                    cursor: 'pointer',
                    opacity: 100
                    gridTemplateRows: 'repeat(1, minmax(0, 1fr))',
                    listStyleType: 'none'
                  }}
                  aria-label="dropdown-list"
                  role="menu"
                >
                  <div
                    id="options-flex"
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      margin: '0.5rem 0'
                    }}
                  >
                    <li id="option-wallet" style={{ width: '100%', alignItems: 'center' }}>
                      <WalletDisconnectButton
                        style={{
                          background: 'linear-gradient(180deg, #604ae5 0%, #813eee 100%)',
                          maxWidth: '128px',
                          maxHeight: '38px',
                          height: '100%',
                          width: '100%',
                          paddingLeft: '1rem',
                          paddingRight: '1rem',
                          paddingTop: '.55rem',
                          paddingBottom: '.55rem',
                          lineHeight: '1.25rem',
                          fontSize: '10px',
                          textAlign: 'center',
                          display: 'inline-flex',
                          justifyContent: 'center',
                          borderRadius: '5px',
                          textTransform: 'uppercase',
                          fontWeight: 'bold',
                          fontFamily: 'Press Start 2P'
                        }}
                      />
                      <div id="option-platform" style={menuListPlatform}>
                        <div style={{ marginBottom: '', marginTop: '1rem' }}>
                          <a href={valURL('https://metateds.com') ? 'https://metateds.com' : ''} target="_blank" rel="noopener noreferrer">
                            <ActionButton>Sign Into Platform</ActionButton>
                          </a>
                        </div>
                      </div>
                    </li>
                  </div>
                </ul>
              )*/}
            </div>
          </div>
        )}
      </div>
      <div id="footer-container" className="footer-container">
        <div style={{ display: 'block', marginBottom: '0.5rem', marginLeft: 'auto', marginRight: 'auto' }}>
          {
            <div className="footer-browser-support">
              <h3>Browsers Supported</h3>
            </div>
          }
          <div id="browser-supported" className="footer-browser-icons">
            {browserLinks.map((value, index) => (
              <div key={index} className="items-center">
                <IconContext.Provider value={{ className: 'global-class-name' }}>
                  <div>{value.icon}</div>
                </IconContext.Provider>
              </div>
            ))}
          </div>
        </div>
        <div id="sponsored-container" className="footer-sponsored-container">
          <div className="footer-supported">
            <h3>Contact Us:</h3>
          </div>
          <div className="footer-social-container">
            <div className="footer-social-media">
              {socialMediaLinks.map((value, index) => (
                <div key={index} className="items-center">
                  <a onClick={value.onclick} style={{ color: 'white' }} href={value.href === '#' ? value.href : valURL(`${value.href}`) ? `${value.href}` : ''} target={value.target} rel={value.rel}>
                    <IconContext.Provider value={{ className: 'global-class-name', color: 'white' }}>
                      <div>{value.icon}</div>
                    </IconContext.Provider>
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const getCountdownDate = (candyMachine: CandyMachineAccount): Date | undefined => {
  if (candyMachine.state.isActive && candyMachine.state.endSettings?.endSettingType.date) {
    return toDate(candyMachine.state.endSettings.number);
  }

  return toDate(candyMachine.state.goLiveDate ? candyMachine.state.goLiveDate : candyMachine.state.isPresale ? new anchor.BN(new Date().getTime() / 1000) : undefined);
};

export default Home;
